import { Urls } from './urls';

export { Urls };
